<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>

    <b-card no-body>
      <b-card-body>
        <div class="broadcast-wrapper">
          <b-row class="broadcast-inner m-0">
            <!-- Left -->
            <b-col
              style="overflow: auto;"
              lg="7"
              class="d-flex flex-column align-items-start broadcast-history py-2"
            >
              <div class="mx-auto">
                <b-tabs
                  v-model="activeTab"
                  align="center"
                >
                  <b-tab
                    title="ตัวอย่าง"
                    active
                  >
                    <div class="cardbc">
                      <div class="btn1" />
                      <div class="btn2" />
                      <div class="btn3" />
                      <div class="btn4" />
                      <div class="card-int">
                        <div
                          class="m-1 rounded p-1 d-flex justify-content-start align-items-center"
                        >
                          <div class="mt-2">

                            <b-collapse :visible="collapse">
                              <b-avatar
                                v-if="broadcastForm.content1"
                                style="
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                "
                                src="/admin.webp"
                                size="30px"
                                class="mr-1 mt-1"
                              />
                              <div
                                v-if="broadcastForm.content1"
                                style="
                                  background-color: #948ff5;
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                  display: inline-block;
                                  color: #fff;
                                "
                                class="broadcast-preview pt-1 px-1 rounded text-custom"
                                v-html="broadcastForm.content1"
                              /></b-collapse>

                            <b-collapse :visible="collapse2">
                              <b-avatar
                                v-if="broadcastForm.content2"
                                style="
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                "
                                src="/admin.webp"
                                size="30px"
                                class="mr-1 mt-1"
                              />
                              <div
                                v-if="broadcastForm.content2"
                                style="
                                  background-color: #948ff5;
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                  display: inline-block;
                                  color: #fff;
                                "
                                class="broadcast-preview pt-1 px-1 mt-1 rounded text-custom"
                                v-html="broadcastForm.content2"
                              /></b-collapse>
                            <b-collapse :visible="collapse3">
                              <b-avatar
                                v-if="broadcastForm.content3"
                                style="
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                "
                                src="/admin.webp"
                                size="30px"
                                class="mr-1 mt-1"
                              />
                              <div
                                v-if="broadcastForm.content3"
                                style="
                                  background-color: #948ff5;
                                  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                                  display: inline-block;
                                  color: #fff;
                                "
                                class="broadcast-preview pt-1 px-1 mt-1 rounded text-custom"
                                v-html="broadcastForm.content3"
                              /></b-collapse>
                          </div>
                        </div>
                      </div>
                      <div class="top">
                        <div class="camera">
                          <div class="int" />
                        </div>
                        <div class="speaker" />
                      </div></div></b-tab>
                  <b-tab
                    title="รายการบรอดแคสต์"
                    @click="getBroadcast"
                  >
                    <div class="w-100">
                      <b-card-title
                        title-tag="h2"
                        class="font-weight-bold"
                      >
                        รายการ Broadcasts
                        <b-form-input
                          v-model="searchQuery"
                          placeholder="ค้นหา Broadcast"
                          class="mt-2"
                        />
                      </b-card-title>

                      <b-table
                        class="text-center"
                        :items="broadcasts"
                        :fields="tableFields"
                        responsive
                        striped
                        hover
                      >
                        <template #cell(content)="data">
                          <b-button
                            size="sm"
                            class=" text-nowrap "
                            @click="viewBroadcast(data.item)"
                          >
                            รายละเอียด
                          </b-button>
                        </template>
                        <!-- <template #cell(created_at)="data">
                          <span
                            class=" text-nowrap"
                          >
                            {{ formatDate(data.item.created_at) }}
                          </span>
                        </template> -->

                        <template #cell(status)="data">
                          <b-button
                            :variant="data.item.status ? 'outline-success' : 'outline-dark'"
                            size="sm"
                            class=" text-nowrap"
                          >
                            {{ data.item.status ? 'ส่งสำเร็จ' :'ยังไม่ส่ง' }}
                          </b-button>
                        </template>

                        <template #cell(edit)="data">
                          <div class="d-flex flex-nowrap">
                            <b-button
                              variant="warning"
                              size="sm"
                              class="mr-1 text-nowrap"
                              @click="editBroadcast(data.item)"
                            >
                              แก้ไข
                            </b-button>
                            <b-button
                              variant="danger"
                              size="sm"
                              class="mr-1 text-nowrap"
                              @click="deleteBroadcast(data.item)"
                            >
                              ลบ
                            </b-button>
                            <b-button
                              variant="success"
                              size="sm"
                              class="text-nowrap"
                              @click="sendBroadcast(data.item)"
                            >
                              ส่ง
                            </b-button></div>
                        </template>
                      </b-table>
                    </div></b-tab>
                </b-tabs>
              </div>
            </b-col>
            <!-- Right -->
            <b-col
              lg="5"
              class="d-flex flex-column broadcast-box"
            >
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  {{ isEditing ? "แก้ไข Broadcast" : "เพิ่ม Broadcast" }}
                  <div>
                    <b-button
                      v-if="isEditing"
                      class="mr-1"
                      variant="warning"
                      size="sm"
                      @click="exitEditMode"
                    >
                      ออกจากการแก้ไข
                    </b-button>
                    <b-button
                      variant="primary"
                      size="sm"
                      :disabled="allCollapsesOpen"
                      @click="newbroadcast"
                    >
                      <i class="fas fa-plus" />
                    </b-button>
                  </div>
                </div>
              </b-card-title>

              <b-form @submit.prevent="saveBroadcast">
                <b-form-group
                  label="ชื่อ Broadcast"
                  label-for="broadcast-title"
                >
                  <b-form-input
                    id="broadcast-title"
                    v-model="broadcastForm.title"
                    placeholder="ชื่อ Broadcast"
                    required
                    :readonly="isView"
                  />
                </b-form-group>

                <b-form-group
                  label="เนื้อหา Broadcast"
                  label-for="broadcast-content"
                >
                  <b-collapse :visible="collapse">
                    <quill-editor
                      ref="quillEditor"
                      v-model="broadcastForm.content1"
                      :options="editorOption"
                    >
                      <div
                        id="toolbar"
                        slot="toolbar"
                      >
                        <span class="ql-formats">
                          <b-dropdown
                            text="😃"
                            variant="light"
                          >
                            <VEmojiPicker @select="selectEmoji" />
                          </b-dropdown>
                          <button class="ql-link" />
                          <button class="ql-image" />
                          <button class="ql-bold" />
                          <button class="ql-italic" />
                          <button class="ql-underline" />
                        </span>
                      </div>
                    </quill-editor>
                  </b-collapse>

                  <b-collapse
                    :visible="collapse2"
                    class="mt-2"
                  >
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="danger"
                        size="sm"
                        class="mb-1"
                        @click="deleteContent(2)"
                      >
                        <i class="fas fa-trash" />
                      </b-button>
                    </div>
                    <quill-editor
                      ref="quillEditor"
                      v-model="broadcastForm.content2"
                      :options="editorOption2"
                    >
                      <div
                        id="toolbar2"
                        slot="toolbar"
                      >
                        <span class="ql-formats">
                          <b-dropdown
                            text="😃"
                            variant="light"
                          >
                            <VEmojiPicker @select="selectEmoji1" />
                          </b-dropdown>
                          <button class="ql-link" />
                          <button
                            class="ql-image"
                            @change="selectimg"
                          />
                          <button class="ql-bold" />
                          <button class="ql-italic" />
                          <button class="ql-underline" />
                        </span>
                      </div>
                    </quill-editor>
                  </b-collapse>

                  <b-collapse
                    :visible="collapse3"
                    class="mt-2"
                  >
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="danger"
                        size="sm"
                        class="mb-1"
                        @click="deleteContent(3)"
                      >
                        <i class="fas fa-trash" />
                      </b-button>
                    </div>
                    <quill-editor
                      ref="quillEditor"
                      v-model="broadcastForm.content3"
                      :options="editorOption3"
                    >
                      <div
                        id="toolbar3"
                        slot="toolbar"
                      >
                        <span class="ql-formats">
                          <b-dropdown
                            text="😃"
                            variant="light"
                          >
                            <VEmojiPicker @select="selectEmoji2" />
                          </b-dropdown>
                          <button class="ql-link" />
                          <button
                            class="ql-image"
                            @change="selectimg"
                          />
                          <button class="ql-bold" />
                          <button class="ql-italic" />
                          <button class="ql-underline" />
                        </span>
                      </div>
                    </quill-editor>
                  </b-collapse>
                </b-form-group>
                <b-row>
                  <b-col>
                    <b-button
                      variant="success"
                      size="sm"
                      type="submit"
                    >
                      {{ isEditing ? "บันทึกการแก้ไข" : "บันทึก" }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
    <b-modal
      v-model="isView"
      title="รายละเอียด"
      cancel
    >
      <div class="cardbc mx-auto">
        <div class="btn1" />
        <div class="btn2" />
        <div class="btn3" />
        <div class="btn4" />
        <div class="card-int">
          <div
            class="m-1 rounded p-1 d-flex justify-content-start align-items-center"
          >
            <div
              v-if="broadcastFormView"
              class="mt-2"
            >

              <b-avatar
                v-if="broadcastFormView.message"
                style="box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)"
                src="/admin.webp"
                size="30px"
                class="mr-1 mt-1"
              />
              <div
                v-if="broadcastFormView.message"
                style="
                    background-color: #948ff5;
                    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                    display: inline-block;
                    color: #fff;
                  "
                class="broadcast-preview pt-1 px-1 rounded text-custom"
                v-html="broadcastFormView.message"
              />

              <b-avatar
                v-if="broadcastFormView.message1"
                style="box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)"
                src="/admin.webp"
                size="30px"
                class="mr-1 mt-1"
              />
              <div
                v-if="broadcastFormView.message1"
                style="
                    background-color: #948ff5;
                    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                    display: inline-block;
                    color: #fff;
                  "
                class="broadcast-preview pt-1 px-1 mt-1 rounded text-custom"
                v-html="broadcastFormView.message1"
              />

              <b-avatar
                v-if="broadcastFormView.message2"
                style="box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)"
                src="/admin.webp"
                size="30px"
                class="mr-1 mt-1"
              />
              <div
                v-if="broadcastFormView.message2"
                style="
                    background-color: #948ff5;
                    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
                    display: inline-block;
                    color: #fff;
                  "
                class="broadcast-preview pt-1 px-1 mt-1 rounded text-custom"
                v-html="broadcastFormView.message2"
              />
            </div>
          </div>
        </div>
        <div class="top">
          <div class="camera">
            <div class="int" />
          </div>
          <div class="speaker" />
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="danger"
          @click="cancel()"
        >
          กลับ
        </b-button>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
// import moment from 'moment-timezone'
// import 'moment/locale/th'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { VEmojiPicker } from 'v-emoji-picker'
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BButton,
  BCardTitle,
  BFormInput,
  BModal,
  BOverlay,
  BCardBody,
  BCard,
  BTable,
  BDropdown,
  BCollapse,
  BAvatar,
  BTab,
  BTabs,
} from 'bootstrap-vue'

export default {
  components: {
    quillEditor,
    VEmojiPicker,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BButton,
    BCardTitle,
    BFormInput,
    BModal,
    BOverlay,
    BCardBody,
    BCard,
    BTable,
    BDropdown,
    BCollapse,
    BAvatar,
    BTab,
    BTabs,
  },
  data() {
    return {
      activeTab: 'ตัวอย่าง',
      isEditing: false,
      isView: false,
      broadcastFormView: null,
      show: false,
      content1: null,
      content2: null,
      content3: null,
      collapse: true,
      collapse2: false,
      collapse3: false,
      allCollapsesOpen: false,
      isImageMode: 0,
      searchQuery: '',
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
        placeholder: 'กรอกข้อความ...',
      },
      editorOption2: {
        modules: {
          toolbar: '#toolbar2',
        },
        placeholder: 'กรอกข้อความ...',
      },
      editorOption3: {
        modules: {
          toolbar: '#toolbar3',
        },
        placeholder: 'กรอกข้อความ...',
      },
      broadcasts: [],
      broadcastForm: {
        title: '',
        content1: '',
        content2: '',
        content3: '',
      },

      tableFields: [
        { key: 'title', label: 'ชื่อ' },
        { key: 'content', label: 'เนื้อหา' },
        { key: 'status', label: 'สถานะ' },
        // { key: "created_at", label: "อัพเดทเมื่อวันที่" },
        { key: 'edit', label: 'จัดการ' },
      ],
      contentDis: false,
    }
  },
  computed: {
    // editor() {
    //   return this.$refs.quillEditor.quill;
    // },
  },
  methods: {
    //   formatDate(date) {
    //   return moment(date).format('DD MMMM YYYY')
    // },
    newbroadcast() {
      if (!this.collapse2) {
        this.collapse2 = true
      } else if (!this.collapse3) {
        this.collapse3 = true
      }
      if (this.collapse2 && this.collapse3) {
        this.allCollapsesOpen = true
      }
    },
    deleteContent(collapseNumber) {
      if (collapseNumber === 2) {
        this.collapse2 = false
        this.content2 = null
      } else if (collapseNumber === 3) {
        this.collapse3 = false
        this.content3 = null
      }
      this.allCollapsesOpen = false
    },
    saveBroadcast() {
      this.show = true
      if (!this.broadcastForm.title || !this.broadcastForm.content1) {
        this.show = false
        return
      }
      const obj = {
        id: this.broadcastForm.id,
        title: this.broadcastForm.title,
        message: this.broadcastForm.content1,
        message1: this.broadcastForm.content2,
        message2: this.broadcastForm.content3,
      }
      this.$http.post('Broadcast/Stroe', obj).then(response => {
        if (response.data.status) {
          this.show = false
          this.activeTab = 1
          this.getBroadcast()
          this.resetForm()
        } else {
          this.show = false
        }
      })
    },
    deleteBroadcast(data) {
      if (data) {
        this.show = true
        const obj = {
          ID: data._id,
        }
        this.$http.post('Broadcast/Delete', obj).then(response => {
          if (response.data.status) {
            this.getBroadcast()
          }
        })
      }
    },
    sendBroadcast(data) {
      if (data) {
        this.show = true
        const obj = {
          ID: data._id,
        }
        this.$http.post('Broadcast/sendMessage', obj).then(response => {
          if (response.data.status) {
            this.getBroadcast()
          }
        })
      }
    },
    async getBroadcast() {
      this.show = true
      const params = {
        perPage: 10,
        page: 1,
        search: this.searchQuery,
      }
      const { data: res } = await this.$http.get('Broadcast/getBroadcast', {
        params,
      })
      this.broadcasts = res.data
      this.show = false
      console.log(res)
    },
    exitEditMode() {
      this.isEditing = false
      this.resetForm()
      this.activeTab = 'ตัวอย่าง'
    },
    resetForm() {
      this.broadcastForm = {
        title: '',
        content1: '',
        content2: '',
        content3: '',
      }
      this.collapse2 = false
      this.collapse3 = false
      this.allCollapsesOpen = false
      this.isEditing = false
    },
    editBroadcast(broadcast) {
      this.isEditing = true
      this.broadcastForm = {
        id: broadcast._id,
        title: broadcast.title,
        content1: broadcast.message,
        content2: broadcast.message1,
        content3: broadcast.message2,
      }
      if (broadcast.message1) {
        this.collapse2 = true
      }
      if (broadcast.message2) {
        this.collapse3 = true
      }
      this.activeTab = 'ตัวอย่าง'
    },
    viewBroadcast(broadcast) {
      this.isView = true
      this.broadcastFormView = broadcast
    },
    selectimg(event) {
      const { files } = event.target
    },
    selectEmoji(dataEmoji) {
      this.broadcastForm.content1 = this.broadcastForm.content1 + dataEmoji.data
    },
    selectEmoji1(dataEmoji) {
      this.broadcastForm.content2 = this.broadcastForm.content2 + dataEmoji.data
    },
    selectEmoji2(dataEmoji) {
      this.broadcastForm.content3 = this.broadcastForm.content3 + dataEmoji.data
    },
  },
}
</script>

<style lang="scss">
.broadcast-preview img {
  max-width: 150px;
  max-height: 150px;
}

.text-custom p,
.text-custom span {
  max-width: 150px;
  font-size: 14px;
}
.cardbc {
  width: 300px;
  height: 600px;
  background: black;
  border-radius: 35px;
  border: 2px solid rgb(40, 40, 40);
  padding: 7px;
  position: relative;
  box-shadow: 2px 5px 15px rgba(0, 0, 0, 0.486);
}

.card-int {
  background-image: linear-gradient(
    to right bottom,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff
  );
  background-size: 200% 200%;
  background-position: 0% 0%;
  height: 100%;
  border-radius: 25px;
  transition: all 0.6s ease-out;
  overflow: auto;
}

.card-int::-webkit-scrollbar {
  display: none;
  }
.card:hover .card-int {
  background-position: 100% 100%;
}

.top {
  position: absolute;
  top: 0px;
  right: 50%;
  transform: translate(50%, 0%);
  width: 35%;
  height: 18px;
  background-color: black;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.speaker {
  position: absolute;
  top: 2px;
  right: 50%;
  transform: translate(50%, 0%);
  width: 40%;
  height: 2px;
  border-radius: 2px;
  background-color: rgb(20, 20, 20);
}

.camera {
  position: absolute;
  top: 6px;
  right: 84%;
  transform: translate(50%, 0%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.048);
}

.int {
  position: absolute;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  background-color: rgba(0, 0, 255, 0.212);
}

.btn1,
.btn2,
.btn3,
.btn4 {
  position: absolute;
  width: 2px;
}

.btn1,
.btn2,
.btn3 {
  height: 45px;
  top: 30%;
  right: -4px;
  background-image: linear-gradient(
    to right,
    #111111,
    #222222,
    #333333,
    #464646,
    #595959
  );
}

.btn2,
.btn3 {
  transform: scale(-1);
  left: -4px;
}

.btn2,
.btn3 {
  transform: scale(-1);
  height: 30px;
}

.btn2 {
  top: 26%;
}

.btn3 {
  top: 36%;
}

.hidden {
  display: block;
  opacity: 0;
  transition: all 0.3s ease-in;
}

.card:hover .hidden {
  opacity: 1;
}

.card:hover .hello {
  transform: translateY(-20px);
}

.broadcast-wrapper {
  .broadcast-history {
    border-right: 1px solid #f0f0f0;
  }

  .broadcast-item {
    padding: 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .broadcast-preview {
    font-size: 14px;
    color: #888;
  }

  .broadcast-box {
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
  }

  .broadcast-history-box {
    height: 60vh;
    overflow-y: auto;
    margin-bottom: 20px;
  }

  .active-broadcast {
    background-color: #e0f7fa;
  }

  .broadcast-form {
    margin-top: 20px;
  }

  .message-text {
    padding: 10px;
    background: #f1f1f1;
    border-radius: 8px;
  }
}
@media (max-width: 990px) {
  .broadcast-preview img {
    max-width: 100px;
    max-height: auto;
    width: auto;
    height: auto;
  }
  .cardbc {
    width: 280px;
    height: 550px;
    background: black;
    border-radius: 35px;
    border: 2px solid rgb(40, 40, 40);
    padding: 7px;
    position: relative;
    box-shadow: 2px 5px 15px rgba(0, 0, 0, 0.486);
  }
  .broadcast-wrapper {
    .broadcast-history {
      border-right: 1px solid #79575700;
    }

    .broadcast-item {
      padding: 0px;
      border-bottom: 1px solid #f0f0f0;
    }
  }
}
</style>
